module.exports = __webpack_public_path__ + "img/dashboard.622dfcfd.png";